export interface Report {
  report_id: number;
  report_name: string;
  description: string;
  generated_date: string;
  report_type: string;
  generated_by: string;
}

export const ReportSummary: Report[] = [
  {
    report_id: 1,
    report_name: 'Position Report - July 2024',
    description: 'A detailed report on positions held by the speculator for July 2024.',
    generated_date: '2024-07-31T10:00:00',
    report_type: 'Position',
    generated_by: 'John Doe',
  },
  {
    report_id: 2,
    report_name: 'Product Performance Report - Q2 2024',
    description: 'Analysis of product performance for the second quarter of 2024.',
    generated_date: '2024-06-30T10:00:00',
    report_type: 'Product Performance',
    generated_by: 'Jane Smith',
  },
  {
    report_id: 3,
    report_name: 'Market Analysis Report - Q2 2024',
    description: 'Market trends and analysis for the second quarter of 2024.',
    generated_date: '2024-06-30T10:00:00',
    report_type: 'Market Analysis',
    generated_by: 'John Doe',
  },
];
